import { createFileRoute } from '@tanstack/react-router'
import { QualityTiersPage } from '@/features/quality-tiers/quality-tiers-page'

type QualityTiersSearch = { category?: number }

export const Route = createFileRoute('/_authenticated/quality-tiers')({
  staticData: { title: 'Quality Tiers' },
  validateSearch: (search: Record<string, unknown>): QualityTiersSearch => {
    const category = Number(search.category)
    return Number.isInteger(category) && category > 0 ? { category } : {}
  },
  component: QualityTiersRoute,
})

function QualityTiersRoute() {
  const { category } = Route.useSearch()
  const navigate = Route.useNavigate()
  return (
    <QualityTiersPage
      categoryId={category ?? null}
      onCategoryChange={(next) => {
        void navigate({ search: { category: next } })
      }}
    />
  )
}
